import { PropTypes } from "prop-types";
import { Waypoint } from "react-waypoint";
import { animated } from "@react-spring/web";

Transition.propTypes = {
  children: PropTypes.func,
  setInview: PropTypes.func,
  styles: PropTypes.object
};
export default function Transition(props) {
  return (
    <Waypoint onEnter={props.setInview(true)}>
      <animated.div style={props.styles}>{props.children}</animated.div>
    </Waypoint>
  );
}
